app.service('shadowDom', function(console) {
	let shadow, shadowHost;

	function loadImage(img) {
		const src = img.dataset.src || img.dataset.original;
		if (src) {
			img.src = src;
			img.classList.add('loaded');
		}
	}

	function updateShadowLazyLoad() {
		if (shadow) { //LazyLoad aktualizowany w shadow DOM
			const lazyImages = shadow.querySelectorAll('img.lazy:not(.loaded)');
			if (lazyImages.length) {
				lazyImages.forEach(img => {
					loadImage(img);
				});
			}
		}
	}

	function initShadowDOM() {
		// Inicjalizacja shadow DOM (inicjalnie dla enkapsulacji opisu produktu)
		const template = shadowHost.querySelector('shadow-template');
		shadow = shadowHost.attachShadow({mode: 'open'});
		
		// przenoszenie HTML do shadow DOM
		shadow.innerHTML = template.innerHTML;
		template.remove();

		// Inicjalizacja custom lazy loading dla obrazków w ramach shadow DOM
		setTimeout(() => {
			updateShadowLazyLoad();
		}, 100);
	}


	function init() {
		shadowHost = document.querySelector('.shadow-host');
		if(shadowHost) {
			initShadowDOM();
		}
	}

	return {
		init,
	};
});
